import { gql } from '@apollo/client';

export interface IMeetingPlaceLinkToAnyPage {
  slug: string;
  sys: {
    locale: string;
  };
  name: string;
  isExternal?: boolean;
  linkTitle?: string;
  linkHref?: string;
  linkTarget?: 'Same' | 'New';
  __typename?: string;
  linkSvg?: {
    file?: { url: string };
  };
  urlSubDirectory?: string;
  contentfulMetadata?: {
    tags: Array<{
      id: string;
    }>;
  };
}

export const MeetingPlaceLinkToAnyPageFragment = gql`
  fragment MeetingPlaceLinkToAnyPage on _Node {
    ... on MeetingPlacePageTenantShop {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageTenantFoodBeverage {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageTenantEntertainment {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageService {
      sys {
        locale
      }
      __typename
      name
      slug
      serviceType(where:{slug_exists:true}) {
        slug
      }
    }
    ... on MeetingPlacePageServiceList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageOffer {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageLeisurePackageOfferItem {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageOfferList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageNewsItem {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageEvent {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageEditorialList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageEditorial {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageEditorialFullWidth {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageSearchResults {
      sys {
        locale
      }
      name
      slug
    }
    ... on MeetingPlacePageFindUs {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageTenantShopList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageTenantFoodbeverageList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageTenantEntertainmentList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageTenantList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageNewsList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageEventList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageLeisurePackageOfferList {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageOccasions {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageFloorPlan {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on MeetingPlacePageIframe {
      sys {
        locale
      }
      __typename
      name
      slug
    }
    ... on LibraryExternalLink {
      sys {
        locale
      }
      __typename
      linkTitle
      linkHref
      linkTarget
    }
    ... on LibraryChinaExternalLink {
      sys {
        locale
      }
      linkTitle
      linkHref
      linkTarget
    }
    ... on LibraryPopupModal {
      sys {
        locale
      }
      __typename
      name
      internalName
      slug
    }
    ... on MeetingPlacePageLegalDocument {
      sys {
        locale
      }
      __typename
      name
      slug
    }
  }
`;
